module.exports = __webpack_public_path__ + "static/media/Tier_1.edb6e8be.svg";